import React from 'react';

import Field from 'circe/forms/components/Field';
import LicensePlate from 'domain/operations/drivers/create/components/LicensePlate/LicensePlate';
import mapFieldToInput from 'domain/operations/drivers/create/components/LicensePlate/mapFieldToInput';

const mappedFieldToInput = mapFieldToInput(LicensePlate);

const LicensePlateField = (props) => <Field component={mappedFieldToInput} {...props} />;

export default LicensePlateField;
